import React, { useState } from "react";
import { defaultColors, styled } from "../stitches.config";
import { bodyLarge } from "./commonStyles/Fonts";
import AddIcon from "./assets/icons/add-icon.svg";
import CloseIcon from "./assets/icons/close-icon.svg";

interface TagButtonProps {
  name: string;
  active: boolean;
  onToggle?: () => void;
}

const TagButton: React.FC<TagButtonProps> = ({
  name,
  active = false,
  onToggle,
}) => {
  const toggleClass = () => {
    // setActive(!isActive);
    onToggle && onToggle();
  };
  return (
    <StyledTagButtonWrapper>
      <StyledTagButton onClick={toggleClass} className={active ? "active" : ""}>
        <span className={bodyLarge()}>{name}</span> <div></div>
      </StyledTagButton>
    </StyledTagButtonWrapper>
  );
};

const StyledTagButtonWrapper = styled("div", {
  "& .active": {
    "& div": {
      backgroundImage: `url("${CloseIcon}")`,
      height: '14px',
      width: '14px'
    },
    background: "$primary",
    border: "0px solid $grayscale75",
    padding: "7px 16px 9px 16px",
    span: {
      color: `${defaultColors.grayscale0} !important`,
    },
  },
});

const StyledTagButton = styled("button", {
  padding: "6px 15px 8px 15px",
  background: "$grayscale0",
  marginBottom: "4px",
  marginLeft: "0px",
  width: "max-content",
  borderWidth: "0px",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  //transition: "0.3s",
  border: "1px solid $grayscale10",
  boxSizing: "border-box",

  "& div": {
    width: "14px",
    height: "14px",
    backgroundImage: `url("${AddIcon}")`,
    backgroundSize: "cover",
    content: "",
    margin: "0 0 0 6px",
  },
});

export default TagButton;
